var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = { class: "checkout-form__main" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col" };
const _hoisted_5 = { class: "col col--half" };
const _hoisted_6 = { class: "col col--half" };
const _hoisted_7 = { class: "col" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col" };
const _hoisted_10 = { class: "col col--half" };
const _hoisted_11 = { class: "col" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col" };
const _hoisted_14 = { class: "checkout-form__bottom" };
const _hoisted_15 = { class: "checkout-form__sum" };
const _hoisted_16 = { class: "checkout-form__sum-value" };
const _hoisted_17 = { class: "checkout-form__finish line line--gap-xl line--aic" };
const _hoisted_18 = { class: "line__item" };
const _hoisted_19 = ["value"];
import Datepicker from "../../components/form/Datepicker.vue";
import FormBlock from "../../components/form/FormBlock.vue";
import FormCheckbox from "../../components/form/FormCheckbox.vue";
import FormInput from "../../components/form/FormInput.vue";
import PhoneControl from "../../components/form/PhoneControl.vue";
import { onMounted, ref, useTemplateRef } from "vue";
import ajax from "../../components/ajax";
import { showModalFromHtml } from "../../components/modal";
import Price from "../../components/Price.vue";
import PaymentBlock from "../order/components/PaymentBlock.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'GiftCardOrderApp',
    props: /*@__PURE__*/ _mergeModels({
        maxDate: Date,
        minDate: Date,
        paymentSystems: { type: Object, required: true },
        sum: { type: Number, required: true },
        recaptcha: {},
    }, {
        "name": {},
        "nameModifiers": {},
        "phone": {},
        "phoneModifiers": {},
        "email": {},
        "emailModifiers": {},
    }),
    emits: ["update:name", "update:phone", "update:email"],
    setup(__props) {
        const name = _useModel(__props, 'name');
        const phone = _useModel(__props, 'phone');
        const email = _useModel(__props, 'email');
        const gift = ref(false);
        const later = ref(false);
        const errors = ref({});
        const form = useTemplateRef('form');
        const locked = ref(false);
        const paymentSystem = ref();
        const recaptchaResponse = ref();
        onMounted(() => {
            setTimeout(function () {
                return __awaiter(this, void 0, void 0, function* () {
                    recaptchaResponse.value = yield grecaptcha.execute(process.env.RECAPTCHA_KEY, { action: 'order_gift_card' });
                });
            }, 2000);
        });
        function onsubmit(event) {
            return __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                lockForm();
                const formData = new FormData(form.value);
                recaptchaResponse.value = yield grecaptcha.execute(process.env.RECAPTCHA_KEY, { action: 'order_gift_card' });
                formData.set('recaptcha', recaptchaResponse.value);
                ajax(form.value.action, formData)
                    .then(response => response.json())
                    .then((data) => {
                    errors.value = data.ok ? {} : data.error;
                    if (!data.ok) {
                        if (data.html) {
                            showModalFromHtml(data.html);
                        }
                        else {
                            unlockForm();
                        }
                        return;
                    }
                    window.location.href = window.location.origin + '/ready/';
                })
                    .catch(unlockForm);
            });
        }
        function lockForm() {
            locked.value = true;
        }
        function unlockForm() {
            locked.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                class: "checkout-form",
                method: "post",
                ref_key: "form",
                ref: form,
                onSubmit: onsubmit
            }, [
                _createElementVNode("fieldset", {
                    class: "always-visible",
                    disabled: locked.value
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(FormBlock, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode(FormInput, {
                                            name: "name",
                                            label: "Как к вам обращаться",
                                            placeholder: "Ваше имя",
                                            required: "",
                                            error: errors.value.name,
                                            modelValue: name.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event))
                                        }, null, 8 /* PROPS */, ["error", "modelValue"])
                                    ]),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createVNode(FormInput, {
                                            name: "phone",
                                            label: "Номер телефона",
                                            error: errors.value.phone,
                                            modelValue: phone.value,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((phone).value = $event)),
                                            required: ""
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(PhoneControl, {
                                                    error: errors.value.phone,
                                                    id: "gift__phone",
                                                    required: "",
                                                    modelValue: phone.value,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((phone).value = $event))
                                                }, null, 8 /* PROPS */, ["error", "modelValue"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["error", "modelValue"])
                                    ]),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(FormInput, {
                                            name: "email",
                                            label: "Эл. почта",
                                            type: "email",
                                            placeholder: "user@example.com",
                                            required: "",
                                            error: errors.value.email,
                                            modelValue: email.value,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((email).value = $event))
                                        }, null, 8 /* PROPS */, ["error", "modelValue"])
                                    ]),
                                    _cache[9] || (_cache[9] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createVNode(FormCheckbox, {
                                            name: "gift",
                                            label: "оформить в подарок другому человеку",
                                            modelValue: gift.value,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((gift).value = $event))
                                        }, null, 8 /* PROPS */, ["modelValue"])
                                    ])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _cache[12] || (_cache[12] = _createTextVNode()),
                        _createVNode(FormBlock, {
                            title: "Информация о получателе",
                            disabled: !gift.value
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createVNode(FormInput, {
                                            name: "recipient_name",
                                            label: "Как обращаться к получателю",
                                            placeholder: "имя",
                                            required: "",
                                            error: errors.value.recipient_name
                                        }, null, 8 /* PROPS */, ["error"])
                                    ]),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createVNode(FormInput, {
                                            name: "recipient_email",
                                            label: "E-mail получателя",
                                            placeholder: "user@example.com",
                                            required: "",
                                            error: errors.value.recipient_email
                                        }, null, 8 /* PROPS */, ["error"])
                                    ]),
                                    _cache[11] || (_cache[11] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createVNode(FormCheckbox, {
                                            name: "later",
                                            label: "отправить позже",
                                            modelValue: later.value,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((later).value = $event))
                                        }, null, 8 /* PROPS */, ["modelValue"])
                                    ])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled"]),
                        _cache[13] || (_cache[13] = _createTextVNode()),
                        _createVNode(FormBlock, {
                            title: "Выберите дату и время отправки",
                            disabled: !(gift.value && later.value)
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createVNode(Datepicker, {
                                            label: "Дата и время отправки",
                                            timepicker: "",
                                            "min-date": __props.minDate,
                                            "max-date": __props.maxDate,
                                            error: errors.value.delivery_date,
                                            required: ""
                                        }, null, 8 /* PROPS */, ["min-date", "max-date", "error"])
                                    ])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled"]),
                        _cache[14] || (_cache[14] = _createTextVNode()),
                        _createVNode(PaymentBlock, {
                            systems: __props.paymentSystems,
                            error: errors.value.payment,
                            sum: __props.sum,
                            modelValue: paymentSystem.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((paymentSystem).value = $event))
                        }, null, 8 /* PROPS */, ["systems", "error", "sum", "modelValue"])
                    ]),
                    _cache[24] || (_cache[24] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "checkout-form__sum-label" }, "Сумма к оплате", -1 /* CACHED */)),
                            _cache[16] || (_cache[16] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(Price, { amount: __props.sum }, null, 8 /* PROPS */, ["amount"])
                            ])
                        ]),
                        _cache[21] || (_cache[21] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_17, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "line__item line__item--grow" }, [
                                _createElementVNode("div", { class: "text text--sm text--placeholder text--right" }, [
                                    _createTextVNode("\n              Нажимая кнопку \"Оплатить сертификат\","),
                                    _createElementVNode("br"),
                                    _createTextVNode("я даю "),
                                    _createElementVNode("a", { href: "/agree/" }, "согласие на обработку персональных данных")
                                ])
                            ], -1 /* CACHED */)),
                            _cache[19] || (_cache[19] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["btn btn--1 btn--l btn--black", { 'btn--loading': locked.value }]),
                                    type: "submit"
                                }, [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("span", { class: "btn__label" }, "Оплатить сертификат", -1 /* CACHED */)
                                    ]))], 2 /* CLASS */)
                            ]),
                            _cache[20] || (_cache[20] = _createTextVNode()),
                            _createElementVNode("input", {
                                type: "hidden",
                                name: "recaptcha",
                                value: recaptchaResponse.value
                            }, null, 8 /* PROPS */, _hoisted_19)
                        ]),
                        _cache[22] || (_cache[22] = _createTextVNode()),
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "checkout-form__captcha text text--xs text--placeholder text--right" }, [
                            _createTextVNode("\n          Сайт защищён при помощи reCAPTCHA."),
                            _createElementVNode("br"),
                            _createTextVNode(" Действует\n          "),
                            _createElementVNode("a", {
                                href: "https://policies.google.com/privacy",
                                target: "_blank"
                            }, "политика конфиденциальности"),
                            _createTextVNode("\n          и "),
                            _createElementVNode("a", {
                                href: "https://policies.google.com/terms",
                                target: "_blank"
                            }, "условия использования"),
                            _createTextVNode(" Google.\n        ")
                        ], -1 /* CACHED */))
                    ])
                ], 8 /* PROPS */, _hoisted_1)
            ], 544 /* NEED_HYDRATION, NEED_PATCH */));
        };
    }
});
